export function adjustCarouselHeight() {
    //Prevent carousel indicators from overlapping text, when one testimonial is longer than the others.
    document.querySelectorAll('.testimonial-carousel').forEach(carousel => {
        const items = carousel.querySelectorAll('.carousel-item');
        let max_height = 0;

        // Temporarily make all items visible to measure heights
        items.forEach(item => {
            item.style.height = '';
            item.style.display = 'block'; // Temporarily display item
            const item_height = item.getBoundingClientRect().height;
            max_height = Math.max(max_height, item_height);
            item.style.display = ''; // Hide it again
        });

        items.forEach(item => {
            item.style.height = `${max_height}px`;
        });
    });
}
